import { Box, Typography } from "@mui/material";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";
import theme from "shared/theme";
import {
  COLOR_GREY_11,
  COLOR_PRIMARY_MAIN,
  COLOR_PRIMARY_BACKGROUND,
  COLOR_GREY_10,
} from "shared/theme/colors";
import { text } from "shared/theme/mixins";

export const StyledBreadcrumbs = styled(Breadcrumbs)`
  ${text(theme.typography.bodyMMedium)};
  color: ${COLOR_GREY_11};

  .MuiBreadcrumbs-li {
    display: flex;
    align-items: center;
  }
`;

export const StyledBreadcrumbIcon = styled(Box)`
  display: flex;
  align-items: center;

  svg {
    width: 20px;
    height: 20px;
    fill: ${COLOR_GREY_10};
  }
`;

export const StyledBreadcrumbsItem = styled(Link, {
  shouldForwardProp: (propName) => propName !== "shouldBeIcon",
})<{ shouldBeIcon?: boolean }>`
  ${text(theme.typography.bodyMMedium)};
  color: ${COLOR_GREY_11};
  text-decoration: unset;
  transition: all 0.4s ease-in-out;
  padding: ${({ shouldBeIcon }) => (shouldBeIcon ? "0" : "0.25rem 0.5rem")};

  &:hover {
    background-color: ${({ shouldBeIcon }) =>
      shouldBeIcon ? "transparent" : COLOR_PRIMARY_BACKGROUND};
    color: ${COLOR_PRIMARY_MAIN};
    border-radius: 6px;
  }
`;

export const StyledExpandIcon = styled(Box)`
  display: flex;
  align-items: center;

  svg {
    transform: rotate(270deg);
    width: 20px;
    height: 20px;
  }
`;

export const StyledTypography = styled(Typography, {
  shouldForwardProp: (propName) => propName !== "active",
})<{ active?: boolean }>`
  ${text(theme.typography.bodyMMedium)};
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  color: ${({ active }) => (active ? COLOR_PRIMARY_MAIN : COLOR_GREY_11)};
  background-color: ${(active) =>
    active ? COLOR_PRIMARY_BACKGROUND : "transparent"};
`;
